
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let u = navigator.userAgent;
		let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		let device= isAndroid?"H5_ANDROID":"H5_IOS"
		import javaHost from '@/bin/javaSetting'
		// webmoyin
		// web
		// let RealHost1 = process.env.NODE_ENV == 'production' ? 'https://moyin-gateway.moyin.com/moyin-real-voice-speaker' : 'https://moyin-gateway-pre.moyin.com/moyin-real-voice-speaker';
		let RealHost1 = process.env.NODE_ENV == 'production' ? 'https://moyin-gateway.moyin.com/moyin-real-voice-new' : 'https://moyin-gateway-pre.moyin.com/moyin-real-voice-new';

		let APIS = {
			getOpenId: `get ${javaHost}/tts-web-api/wechat/openId?device=${device}`, //不变
			getOrderInfo: `get ${RealHost1}/order/getOrderInfo?device=${device}`, //已修改
			getUser: `get ${javaHost}/moyin-account/v1/user?device=${device}`, //不变
			userExists: `get ${javaHost}/moyin-account/v1/user/exists?device=${device}`, //不变
			getPayStatus: `get ${javaHost}/tts-web-api/v1/realVoiceSpeaker/checkPayment?device=${device}`, //暂时未使用新接口
			wxPay: {
				custom: true,
				method: 'post',
				url: (data: any) => `${javaHost}/moyin-real-voice-new/pay/wxPay?wwToken=${ //新接口
			  data.wwToken
			}&orderId=${
			  data.orderId
			}&openId=${
			  data.openId
			}&phone=${
			  data.phone
			}&device=${
				device
			}&payType=${
				data.payType
			}`,
			},
			getCaptcha: `get tts/captcha?device=${device}`, //不变
			realLogin: `get tts/captcha/login?device=${device}`, //不变
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"realVoicePayPage"
			})
		}